export const Socials = [
  "Facebook",
  "Instagram",
  // "TikTok",
  // "Twitter",
  // "YouTube",
  // "LinkedIn",
];
